import React from 'react';

import { List } from '@material-ui/core';
import { isUndefined } from 'lodash';
import PropTypes from 'prop-types';

import { MenuDropdown, MenuList } from './components';
import { Container } from './style';

export default function Navigation({ lists }) {
  return (
    <Container>
      <List>
        {lists.map((list) =>
          isUndefined(list.children) ? (
            <MenuList
              key={list.key}
              icon={list.icon}
              title={list.title}
              url={list.url}
            />
          ) : (
            <MenuDropdown key={list.key} items={list} />
          )
        )}
      </List>
    </Container>
  );
}

Navigation.propTypes = {
  lists: PropTypes.arrayOf(PropTypes.any).isRequired,
};
